import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import'rxjs/add/operator/map';
import'rxjs/add/operator/catch';
import'rxjs/add/observable/throw';
import'rxjs/add/operator/retry';
import { catchError, retry } from 'rxjs/operators';
import { PathModel } from './PathModel';
export class RESTClientService {
private header: HttpHeaders = new HttpHeaders();
/**
 * @param {?} _http
 */
constructor(private _http: HttpClient) { }
/**
 * @param {?} path
 * @param {?=} queryParams
 * @return {?}
 */
public get(path: string | PathModel, queryParams?: { [propName: string]: any }): Observable<any> {
    const /** @type {?} */ url = path.toString();
    return this._http.get(url, this.getHeader());
  }
/**
 * @param {?} path
 * @param {?} body
 * @return {?}
 */
public post(path: string | PathModel, body: any) {
    const /** @type {?} */ url = path.toString();
    return this._http.post(url, body)
      .map((res: Response) => {
        const /** @type {?} */ retorno = res;
      })
      .catch((e: any) => {
        return Observable.throw(e);
      });
  }
/**
 * @param {?} path
 * @param {?} body
 * @return {?}
 */
public put(path: string | PathModel, body: any) {
    const /** @type {?} */ url = path.toString();
    return this._http.put(url, body)
      .map((res) => res)
      .catch((e: any) => {
        return Observable.throw(e);
      });
  }
/**
 * @param {?} path
 * @param {?=} queryParams
 * @return {?}
 */
public delete(path: string | PathModel, queryParams?: { [propName: string]: any }) {
    const /** @type {?} */ url = path.toString();
    return this._http.delete(url, this.getHeader())
      .map((res) => res)
      .catch((e: any) => {
        return Observable.throw(e);
      });
  }
/**
 * @return {?}
 */
public getHeader() {
    const /** @type {?} */ headers = new Headers({ 'Access-Control-Allow-Origin': '*' });
    this.header.append('Content-Type', 'application/json');
    const /** @type {?} */ opts: any = { headers: this.header };
    return opts;
  }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: HttpClient, },
];
}

function RESTClientService_tsickle_Closure_declarations() {
/** @type {?} */
RESTClientService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RESTClientService.ctorParameters;
/** @type {?} */
RESTClientService.prototype.header;
/** @type {?} */
RESTClientService.prototype._http;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
